import { IStepper } from "../../../../shared/model/IStepper";

export const initialStepper: IStepper = {
  previous: 0,
  current: 1,
  next: 2,
  firstStep: 1,
  lastStep: 3,
  steps: ["1", "2", "3"],
};
